import React from 'react';

import { useFeatureAppConfig } from './services/use-feature-app-config';
import { HandleDataLoad } from './components/handle-data-load';
import { ShowroomModel } from './typings/model-overview';
import { styled, Breakpoints } from '@vw-marketing/us-components';
import { RecoilRoot } from 'recoil';
import DealerReviewLoader from './components/dealer-reviews-loader';
export interface AppProps {
  readonly baseUrl?: string;
}

declare var vwa_d6_cms: any;

const FiveStarsAppWrapper: any = styled.div`
  padding: 0 20px;
  @media (min-width: ${Breakpoints.b560}px) {
    padding: 0 ${props => props.theme.size.grid002};
  }
  overflow: hidden;
  max-width: 100vw;
`;
export function App({ baseUrl }: AppProps): JSX.Element | null {
  const { mode, modelConfiguration } = useFeatureAppConfig();
  console.log(baseUrl);
  let showroomModel: ShowroomModel | undefined = undefined;
  // showroomModel = {
  //   carlineId: '30290',
  // };
  if (modelConfiguration?.carlineId) {
    showroomModel = { carlineId: modelConfiguration?.carlineId };
  } else if (
    !modelConfiguration ||
    modelConfiguration.useCarConfigurationService === 'true'
  ) {
    try {
      if (
        typeof vwa_d6_cms !== undefined &&
        vwa_d6_cms &&
        vwa_d6_cms.browserRegistry &&
        vwa_d6_cms.browserRegistry.singletonInstances &&
        vwa_d6_cms.browserRegistry.singletonInstances.CarConfigurationService &&
        vwa_d6_cms.browserRegistry.singletonInstances.CarConfigurationService.get()
      ) {
        showroomModel = vwa_d6_cms.browserRegistry.singletonInstances.CarConfigurationService.get();
      }
    } catch (e) {
      console.log('Global vwa_d6_cms ', e);
    }
  }
  return (
    <FiveStarsAppWrapper id="fiveStartFA">
      {mode?.includes('dealer-reviews') ? (
        <RecoilRoot>
          <DealerReviewLoader />
        </RecoilRoot>
      ) : (
        <HandleDataLoad showRoomModel={showroomModel} />
      )}
    </FiveStarsAppWrapper>
  );
}
